<div
  *ngIf="isOpen"
  class="contact-modal-overlay"
  role="presentation"
  (click)="onOverlayClick($event)">
  <section
    class="contact-modal"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="'contact-modal-title'">
    <header class="contact-modal-header"   [style.background-color]="data?.color">
      <h2 id="contact-modal-title" class="quicksand-bold">{{ data?.contactos?.titulo || 'CONTACTOS' }}</h2>
      <button
        type="button"
        class="contact-modal-close"
        aria-label="Cerrar contactos"
        (click)="closeModal()">
        <span aria-hidden="true">×</span>
      </button>
    </header>

    <div class="contact-modal-body">
      <section class="contact-modal-list" *ngFor="let lista of data.contactItems">
        <h3 class="quicksand-bold" [style.color]="data?.color">{{ lista.title }}</h3>

        <article class="contact-modal-item" *ngFor="let item of lista.subItems">
          <div class="contact-modal-careers nunito-bold">
            <div *ngFor="let title of item.titles">{{ title }}</div>
          </div>
           <!-- si value es tipo mail -->
          <a *ngIf="item.type=='Email'" class="contact-modal-email nunito-regular" [href]="'mailto:' + item.value">
            <img src="./assets/facultades/email.png" alt="">
            <span>{{ item.value }}</span>
          </a>

          <!-- si value es tipo telefono -->
          <a *ngIf="item.type=='Tel\u00e9fono'" class="contact-modal-email nunito-regular" [href]="'tel:' + item.value">
            <img src="./assets/facultades/phone.png" alt="">
            <span>{{ item.value }}</span>
          </a>

          <!-- si value es tipo wsp -->
          <a *ngIf="item.type=='WhatsApp'" class="contact-modal-email nunito-regular" [href]="'https://wa.me/' + item.value" target="_blank" rel="noopener noreferrer">
            <img src="./assets/facultades/whatsapp.png" alt="">
            <span>{{ item.value }}</span>
          </a>
        </article>
      </section>
    </div>

    <footer class="contact-modal-footer" [style.background-color]="data?.color"></footer>
  </section>
</div>
